import layout from "~/layout/App/Index.vue";
import auth from "../middleware/auth";
import processorsRoutes from "~/router/modules/processorsRoutes";
import PageNotFound from "~/views/404.vue";

const routes = {
  path: "/cabinet/:contractName/contract", component: layout, name: "contract.cabinet", meta: {
    middleware: auth, breadcrumb: "breadcrumb.contract.cabinet"
  }, props: {
    navbarType: "main"
  }, children: [...processorsRoutes, {
    path: "/404", name: "PageNotFound", component: PageNotFound
  }, {
    path: "", component: () => import("~/views/ContractDashboard/Index"), name: "contract.cabinet.index", meta: {
      middleware: auth, breadcrumb: "breadcrumb.database.main", breadcrumbWidth: "max-w-7xl"
    }
  }, {
    path: "site", component: () => import("~/views/Site/Index"), name: "contract.cabinet.site.index", meta: {
      middleware: auth, breadcrumb: "breadcrumb.site.index"
    }
  }, {
    path: "site/create", component: () => import("~/views/Site/Create"), name: "contract.cabinet.site.create", meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.site.index",
        route: "contract.cabinet.site.index"
      }, { name: "breadcrumb.terminal" }]
    }
  }, {
    path: "site/:siteId/edit",
    component: () => import("~/views/Site/Edit.vue"),
    name: "contract.cabinet.site.edit",
    meta: {
      middleware: auth,
      breadcrumb: [{ name: "breadcrumb.site.index", route: "contract.cabinet.site.index" }, { name: "breadcrumb.edit" }]
    }
  }, {
    path: "site/:siteId/terminal",
    component: () => import("~/views/Site/Terminal.vue"),
    name: "contract.cabinet.site.terminal",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.site.index",
        route: "contract.cabinet.site.index"
      }, { name: "breadcrumb.terminal" }]
    }
  }, {
    path: "customers/storages",
    component: () => import("~/views/Customer/Storage/Index"),
    name: "contract.cabinet.customers.index",
    meta: {
      breadcrumb: "breadcrumb.customers.index", middleware: auth
    }
  }, {
    path: "customers/databases",
    component: () => import("~/views/Customer/Database/Index"),
    name: "contract.cabinet.customers.db.index",
    meta: {
      breadcrumb: "breadcrumb.customers.index", middleware: auth
    }
  }, {
    path: "storage", component: () => import("~/views/Storage/Index"), name: "contract.cabinet.storage.index", meta: {
      breadcrumb: "breadcrumb.storage.index", middleware: auth
    }
  }, {
    path: "storage-manager",
    component: () => import("~/views/StorageManager/Index"),
    name: "contract.cabinet.storageManager.index",
    meta: {
      breadcrumb: "breadcrumb.storageManager.index", middleware: auth
    }
  }, {
    path: "storage/create",
    component: () => import("~/views/Storage/Create"),
    name: "contract.cabinet.storage.create",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.storage.index",
        route: "contract.cabinet.storage.index"
      }, { name: "breadcrumb.create" }]
    }
  }, {
    path: "storage/:storageId/edit",
    component: () => import("~/views/Storage/Edit.vue"),
    name: "contract.cabinet.storage.edit",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.storage.index",
        route: "contract.cabinet.storage.index"
      }, { name: "breadcrumb.edit" }]
    }
  }, {
    path: "load", component: () => import("~/views/Load/Index"), name: "contract.cabinet.load.index", meta: {
      breadcrumb: "breadcrumb.load.index", middleware: auth
    }
  }, {
    path: "databases",
    component: () => import("~/views/Database/Index"),
    name: "contract.cabinet.database.index",
    meta: {
      middleware: auth, breadcrumb: "breadcrumb.database.index"
    }
  }, {
    path: "database/:typeDBId/:typeVersionId/create",
    component: () => import("~/views/Database/Create"),
    name: "contract.cabinet.database.create",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.database.index",
        route: "contract.cabinet.database.index"
      }, { name: "breadcrumb.create" }]
    }
  }, {
    path: "database/:databaseId/edit",
    component: () => import("~/views/Database/Edit"),
    name: "contract.cabinet.database.edit",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.database.index",
        route: "contract.cabinet.database.index"
      }, { name: "breadcrumb.edit" }]
    }
  }, {
    path: "certificates",
    component: () => import("~/views/Certificate/Index"),
    name: "contract.cabinet.certificate.index",
    meta: {
      middleware: auth, breadcrumb: "breadcrumb.certificate.index"
    }
  }, {
    path: "certificate/create",
    component: () => import("~/views/Certificate/Create"),
    name: "contract.cabinet.certificate.create",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.certificate.index",
        route: "contract.cabinet.certificate.index"
      }, { name: "breadcrumb.create" }]
    }
  }, {
    path: "certificate/:certificateId/edit",
    component: () => import("~/views/Certificate/Edit"),
    name: "contract.cabinet.certificate.edit",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.certificate.index",
        route: "contract.cabinet.certificate.index"
      }, { name: "breadcrumb.edit" }]
    }
  }, {
    path: "balance", component: () => import("~/views/Balance/Index"), name: "contract.cabinet.balance", meta: {
      breadcrumb: "breadcrumb.balance.index", middleware: auth
    }
  }, {
    path: "balance/insights",
    component: () => import("~/views/Balance/Insights"),
    name: "contract.cabinet.balance.insights",
    meta: {
      middleware: auth,
      breadcrumb: [
        {
          name: "breadcrumb.balance.index",
          route: "contract.cabinet.balance"
        },
        { name: "Balance Insights" }
      ]
    }
  }, {
    path: "domains", component: () => import("~/views/Domain/Index"), name: "contract.cabinet.domain.index", meta: {
      breadcrumb: "breadcrumb.domain.index", middleware: auth
    }
  }, {
    path: "domains/:domainId/edit",
    component: () => import("~/views/Domain/Update"),
    name: "contract.cabinet.domains.update",
    meta: {
      breadcrumb: [{
        name: "breadcrumb.domain.index",
        route: "contract.cabinet.domain.index"
      }, { name: "breadcrumb.domains.update" }], middleware: auth
    }
  }, {
    path: "domain/:domainId/records",
    component: () => import("~/views/Domain/Records.vue"),
    name: "contract.cabinet.domains.records.index",
    meta: {
      breadcrumb: [{
        name: "breadcrumb.domain.index",
        route: "contract.cabinet.domain.index"
      }, { name: "breadcrumb.records" }], middleware: auth
    }
  }, {
    path: "cache", component: () => import("~/views/Cache/Index"), name: "contract.cabinet.cache.index", meta: {
      breadcrumb: "breadcrumb.cache.index", middleware: auth
    }
  }, {
    path: "processors/edit",
    component: () => import("~/views/Processors/Update"),
    name: "contract.cabinet.processors.update",
    meta: {
      breadcrumb: "breadcrumb.processors.update", middleware: auth
    }
  }, {
    path: "logs", component: () => import("~/views/Log/Index"), name: "contract.cabinet.logs.index", meta: {
      breadcrumb: "breadcrumb.logs.index", middleware: auth
    }
  }, {
    path: "logs/details",
    component: () => import("~/views/Log/Details"),
    name: "contract.cabinet.logs.details",
    meta: {
      breadcrumb: [{
        name: "breadcrumb.logs.index",
        route: "contract.cabinet.logs.index"
      }, { name: "breadcrumb.logs.details" }], middleware: auth
    }
  }, {
    path: "crons", component: () => import("~/views/Cron/Index"), name: "contract.cabinet.crons.index", meta: {
      middleware: auth, breadcrumb: "breadcrumb.crons.index"
    }
  }, {
    path: "crons/:id/edit",
    component: () => import("~/views/Cron/Edit.vue"),
    name: "contract.cabinet.cron.edit",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.crons.index",
        route: "contract.cabinet.crons.index"
      }, { name: "breadcrumb.edit" }]
    }
  }, {
    path: "crons/create",
    component: () => import("~/views/Cron/Create"),
    name: "contract.cabinet.crons.create",
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.crons.index",
        route: "contract.cabinet.crons.index"
      }, { name: "breadcrumb.create" }]
    }
  }, {
    path: "backups/storage/plan",
    component: () => import("~/views/Backup/StoragePlan/Index.vue"),
    name: "contract.cabinet.backup.storage.plan.index",
    meta: {
      breadcrumb: "breadcrumb.backup.storagePlan.index", middleware: auth
    }
  }, {
    path: "backups/storage",
    component: () => import("~/views/Backup/Storage/Index.vue"),
    name: "contract.cabinet.backups.storage.index",
    meta: {
      breadcrumb: "breadcrumb.backup.storage.index", middleware: auth
    }
  }, {
    path: "backup/storage/plan/create",
    name: "contract.cabinet.backup.storage.plan.create",
    component: () => import("~/views/Backup/StoragePlan/Create.vue"),
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.backup.storagePlan.index",
        route: "contract.cabinet.backup.storage.plan.index"
      }, { name: "breadcrumb.create" }]
    }
  }, {
    path: "backup/storage/plan/:planId/edit",
    name: "contract.cabinet.backup.storage.plan.edit",
    component: () => import("~/views/Backup/StoragePlan/Edit.vue"),
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.backup.storagePlan.index",
        route: "contract.cabinet.backup.storage.plan.index"
      }, { name: "breadcrumb.edit" }]
    }
  }, {
    path: "backups/database",
    component: () => import("~/views/Backup/Database/Index.vue"),
    name: "contract.cabinet.backups.database.index",
    meta: {
      breadcrumb: "breadcrumb.backup.database.index", middleware: auth
    }
  }, {
    path: "backups/database/plan",
    component: () => import("~/views/Backup/DatabasePlan/Index.vue"),
    name: "contract.cabinet.backup.database.plan.index",
    meta: {
      breadcrumb: "breadcrumb.backup.databasePlan.index", middleware: auth
    }
  }, {
    path: "backup/database/plan/create",
    name: "contract.cabinet.backup.database.plan.create",
    component: () => import("~/views/Backup/DatabasePlan/Create.vue"),
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.backup.databasePlan.index",
        route: "contract.cabinet.backup.database.plan.index"
      }, { name: "breadcrumb.create" }]
    }
  }, {
    path: "backup/database/plan/:planId/edit",
    name: "contract.cabinet.backup.database.plan.edit",
    component: () => import("~/views/Backup/DatabasePlan/Edit.vue"),
    meta: {
      middleware: auth,
      breadcrumb: [{
        name: "breadcrumb.backup.databasePlan.index",
        route: "contract.cabinet.backup.database.plan.index"
      }, { name: "breadcrumb.edit" }]
    }
  }, {
    path: "histories",
    component: () => import("~/views/ContractHistory/Index"),
    name: "contract.cabinet.history.index",
    meta: {
      breadcrumb: "breadcrumb.history.index", middleware: auth
    }
  }]
};

export default routes;
